import script from "./CreateDocumentSubjectsVIew.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateDocumentSubjectsVIew.vue?vue&type=script&setup=true&lang=ts"

import "./CreateDocumentSubjectsVIew.vue?vue&type=style&index=0&id=4daa4b36&lang=scss"

const __exports__ = script;

export default __exports__